import React from "react";
import "./Certificates.css";
import C1 from "../../../Assets/Certificates/c1.jpg";
import C2 from "../../../Assets/Certificates/c2.jpg";
import C3 from "../../../Assets/Certificates/c3.jpg";
import C4 from "../../../Assets/Certificates/c4.jpg";
import C5 from "../../../Assets/Certificates/c5.jpg";
import C6 from "../../../Assets/Certificates/c6.jpg";

const Certificates = () => {
  return (
    <>
      <section className="gallery-wrapper certificate-wrapper">
        <div className="section-title">
          <h1 className="text-white">
            Received <span>Certificates</span>
          </h1>
        </div>
        <div className="certificate-group">
          <div className="certificate">
            <img src={C1} alt="" className="img-fluid certificate-img" />
            <a href={C1} download>
              <div className="overlay">
                <i className="download-icon"></i>
                <span>Download</span>
              </div>
            </a>
          </div>
          <div className="certificate">
            <img src={C2} alt="" className="img-fluid certificate-img" />
            <a href={C2} download>
              <div className="overlay">
                <i className="download-icon"></i>
                <span>Download</span>
              </div>
            </a>
          </div>
          <div className="certificate">
            <img src={C3} alt="" className="img-fluid certificate-img" />
            <a href={C3} download>
              <div className="overlay">
                <i className="download-icon"></i>
                <span>Download</span>
              </div>
            </a>
          </div>
          <div className="certificate">
            <img src={C4} alt="" className="img-fluid certificate-img" />
            <a href={C4} download>
              <div className="overlay">
                <i className="download-icon"></i>
                <span>Download</span>
              </div>
            </a>
          </div>
          <div className="certificate">
            <img src={C5} alt="" className="img-fluid certificate-img" />
            <a href={C5} download>
              <div className="overlay">
                <i className="download-icon"></i>
                <span>Download</span>
              </div>
            </a>
          </div>
          <div className="certificate">
            <img src={C6} alt="" className="img-fluid certificate-img" />
            <a href={C6} download>
              <div className="overlay">
                <i className="download-icon"></i>
                <span>Download</span>
              </div>
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Certificates;
